import { createFileRoute } from '@tanstack/react-router'
import { getBlogPost, orNotFound } from '~/lib/content/content'
import { cacheHeaders } from '~/lib/site/cache'
import { formatDate } from '~/lib/date'
import { articleHead } from '~/lib/site/seo'
import { Container } from '~/components/ui/Container'
import { ContentCard } from '~/components/ui/ContentCard'
import { ArticleLayout } from '~/components/sections/ArticleLayout'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'

export const Route = createFileRoute('/blog/$slug')({
  loader: ({ params }) => orNotFound(getBlogPost({ data: params.slug })),
  headers: () => cacheHeaders.content,
  head: ({ loaderData }) => {
    const post = loaderData?.post
    if (!post) return {}
    return articleHead({
      type: 'BlogPosting',
      path: `/blog/${post.slug}`,
      ...post,
      image: (post.thumbnail ?? post.image)?.src,
    })
  },
  component: BlogPost,
})

function BlogPost() {
  const { post, others } = Route.useLoaderData()
  return (
    <>
      <ArticleLayout
        kicker={post.category}
        author={post.author}
        date={post.date}
        title={post.title}
        image={post.image}
        quote={post.quote}
        html={post.html}
        audio={post.audio}
        search={{ type: 'blog', label: 'Blog' }}
      />

      {others.length > 0 && (
        <Container className="max-w-[1100px] pb-16">
          <h2 className="mt-5 text-[32px] leading-9 font-bold text-fg">
            Other articles
          </h2>
          <ul className="mt-2.5 grid gap-6 md:grid-cols-3">
            {others.map((o) => (
              <li key={o.slug}>
                <ContentCard
                  to={{
                    to: '/blog/$slug',
                    params: { slug: o.slug },
                  }}
                  image={o.thumbnail ?? o.image}
                  eyebrow="Blog"
                  title={o.title}
                  meta={formatDate(o.date)}
                  summary={o.summary}
                  headingLevel="h3"
                />
              </li>
            ))}
          </ul>
        </Container>
      )}

      <DonateSignupBand />
    </>
  )
}
